import { render } from "./HomeFeaturing.vue?vue&type=template&id=759bb57e"
const script = {}

import "./HomeFeaturing.vue?vue&type=style&index=0&id=759bb57e&lang=css"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__